"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedreturnssm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedreturnssm` : '') + (description ? ` desc-brandedreturnssm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedreturnssm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedreturnssm"
  }, description), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "10",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.31 4H10.3c-.2 0-.4.1-.55.26a.98.98 0 0 0-.22.64c0 .24.08.46.22.63.15.17.34.27.55.27h2.01c.64.03 1.25.35 1.7.9.44.53.49 1.24.49 1.99s-.05 1.48-.5 2.02c-.44.54-1.05.87-1.69.9H7.68a.12.12 0 0 1-.1-.04.16.16 0 0 1-.03-.11V9.55a.67.67 0 0 0-.08-.33.54.54 0 0 0-.24-.23.45.45 0 0 0-.3-.03.5.5 0 0 0-.26.16l-2.52 2.93a.61.61 0 0 0-.11.2.68.68 0 0 0 .1.65l2.53 2.92a.45.45 0 0 0 .37.17c.06.01.12 0 .19-.02a.5.5 0 0 0 .24-.24.7.7 0 0 0 .08-.35v-1.85c0-.04 0-.08.03-.11a.12.12 0 0 1 .1-.04h4.63c1-.1 1.94-.64 2.63-1.51.68-.87 1.06-2 1.06-3.18 0-1.18-.38-2.31-1.06-3.18A3.87 3.87 0 0 0 12.3 4Z",
    fill: "white"
  }));
};
var _default = exports.default = brandedreturnssm;